import { useContext } from "react";
import { StatusContext } from "../../../store/StatusContextProvider";
import StatusGroupCard from "../../../components/StatusGroupCard/StatusGroupCard";
import StatusInfoCard from "../../../components/StatusInfoCard/StatusInfoCard";
import * as Styles from "../Checking.styles";

interface statusCardGroupsType {
  id: number;
  title: string;
}

export default function CheckingStatusGroupPanel() {
  const { getStatusOptionsArray } = useContext(StatusContext);

  const statusCardGroupQuantidadeTitle: string = "Quantidade";
  const statusCardGroupProdutoTitle: string = "Divergência de produto";

  const statusCardGroupsValues: statusCardGroupsType[] = [
    { id: 1, title: statusCardGroupQuantidadeTitle },
    { id: 2, title: statusCardGroupProdutoTitle },
  ];

  return (
    <Styles.HeaderCardsContainer>
      <Styles.CustomHeaderOptions>
        {statusCardGroupsValues.map((group) => (
          <StatusGroupCard key={group.id} title={group.title}>
            {getStatusOptionsArray(group.id).map((item, index) => (
              <StatusInfoCard image={item.image} title={item.title} key={index} total={item.totalStatus} />
            ))}
          </StatusGroupCard>
        ))}
      </Styles.CustomHeaderOptions>
    </Styles.HeaderCardsContainer>
  );
}
